@if (step == forgetFlowStepEnum.userName) {
<form [formGroup]="usernameForm" class="w-full flex flex-wrap justify-center content-start mt-2">
    <span class="w-full text-base font-medium text-start mb-2">فراموشی رمز عبور</span>
    <span class="w-full text-xs font-regular text-start mb-5">برای بازیابی رمز عبور شمارهٔ موبایل یا آدرس ایمیل خود را
        وارد کنید.</span>

    <input StandardNumber formControlName="username" class="w-full mb-5 !bg-white border !border-[#BDBDBD]" type="text"
        placeholder="شمارهٔ موبایل یا آدرس ایمیل">

    <button [appButtonLoader]="submitUsernameLoading" class="w-full btn btn btn-green-flat mb-2 md:MT-10" [disabled]="usernameForm.invalid"
        (click)="submitUsername()">بازیابی رمز عبور</button>
    <button class=" btn btn-green mb-5 !p-0" (click)="loginWithOtp()">ورود با رمز یکبار مصرف</button>

</form>
}

@else if(step == forgetFlowStepEnum.verification) {
<div class="w-full flex flex-wrap justify-center content-start mt-2">
    <span class="w-full text-base font-medium text-start mb-2">کد تأیید را وارد کنید</span>

    @if (initialData.type === 'email') {
    <span class="w-full text-sm font-regular text-start mb-4">کد ارسال‌شده به آدرس ایمیل را وارد کنید.</span>
    <span class="w-full text-sm font-regular text-start mb-2">{{initialData.userName}}</span>
    }
    @else {
    <span class="w-full text-sm font-regular text-start mb-2">کد ارسال‌شده به شماره {{initialData.userName}} را وارد
        کنید.</span>
    }

    <div class="w-full flex flex-warp justify-center">
        <button class="btn btn-green mb-6 mx-4" (click)="changeUserName()">
            ویرایش
            @if (initialData.type === 'email') {
            ایمیل
            }
            @else {
                شمارهٔ موبایل
            }
        </button>

    </div>


    <app-otp-input class="w-2/3 md:w-5/12 mb-10" (codeCompleted)="verifyCode($event)"></app-otp-input>

    <button [appButtonLoader]="verificationLoading" class="w-full btn btn btn-green-flat mb-2 md:MT-10" (click)="verifyCode()" [disabled]="code?.length != 4">تأیید و
        ادامه</button>
    <button class="w-full btn btn-green mb-5" (click)="loginWithOtp()">ورود با رمز یکبار مصرف</button>

</div>
}


@else if(step == forgetFlowStepEnum.setPassword) {
<form [formGroup]="newPasswordForm" class="w-full flex flex-wrap justify-center content-start mt-2">
    <span class="w-full text-base font-medium text-start mb-2">فراموشی رمز عبور</span>
    <span class="w-full text-sm font-regular text-start mb-5">برای بازیابی رمز عبور شمارهٔ موبایل یا آدرس ایمیل خود را
        وارد کنید.</span>


        <div class="relative w-full mb-3 rounded-lg">
            <input formControlName="password" class="w-full !bg-white border !border-[#BDBDBD]" type="text"
                placeholder="رمز عبور (حداقل ۶ کاراکتر)" [type]="passwordVisible ? 'text' : 'password'">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 icon text-base text-gray-500 cursor-pointer"
                (click)="passwordVisible = !passwordVisible" [ngClass]="passwordVisible ? 'eye-off-filled' : 'eye-regular'">
            </span>
        </div>
    
        <div class="relative w-full mb-6 rounded-lg">
            <input formControlName="pass_repeat" class="w-full !bg-white border !border-[#BDBDBD]" type="text"
                placeholder="تکرار رمز عبور" [type]="repeatPasswordVisible ? 'text' : 'password'">
    
            <span class="absolute left-3 top-1/2 -translate-y-1/2 icon text-base text-gray-500 cursor-pointer"
                (click)="repeatPasswordVisible = !repeatPasswordVisible"
                [ngClass]="repeatPasswordVisible ? 'eye-off-filled' : 'eye-regular'">
            </span>
        </div>

    <button [appButtonLoader]="confirmPasswordLoading" class="w-full btn btn btn-green-flat mb-2 md:MT-10" [disabled]="newPasswordForm.invalid"
        (click)="submitNewPassword()">ثبت رمز عبور جدید</button>

</form>
}